import styled from "styled-components";

const ClientDashboardContainer = styled.div`
  margin-right: 40px;
  overflow: "auto";
`;

export default ClientDashboardContainer;
